import { ref, computed } from "vue";
import { fabric } from "fabric";

import { store } from "@/store";

import { canvas } from "@/canvas-api/Canvas";
import { reject } from "lodash";

const currentLabelBgColor = computed<string>(() => store.getters.currentLabelBgColor);
const isRotated = computed<boolean>(() =>
  store.getters.canvasOrientation === "rotated" ? true : false
);

export const fetchCanvasJSON = ref(false);
export const canvasJSON = ref("");
export const clearCanvasJSONValues = () => {
  fetchCanvasJSON.value = false;
  canvasJSON.value = "";
};

export const setCanvasJson = (): Promise<string | undefined> => {
  return new Promise((resolve) => {
    canvas.value.clone(
      function(clone: fabric.Canvas) {
        const canvasObjects = clone.getObjects();

        let i = 0;
        while (canvasObjects[i]) {
          if (
            (canvasObjects[i].name && canvasObjects[i].name?.includes("objectIcon")) ||
            canvasObjects[i].name === "labelCanvas" ||
            canvasObjects[i].name === "actualLabelSize" ||
            canvasObjects[i].name === "safeZone" ||
            canvasObjects[i].name === "bleedLine" ||
            canvasObjects[i].name === "bleedLineTop" ||
            canvasObjects[i].name === "snapLineGroup" ||
            canvasObjects[i].name === "iconsHelperLine" ||
            canvasObjects[i].name === "guidelinesBtn"
          ) {
            clone.remove(canvasObjects[i]);
          }

          i++;
        }

        const canvasAsJson: any = clone.toJSON(["name", "id", "backgroundColor"]);

        canvasAsJson["canvasCenter"] = clone.getCenter();
        canvasAsJson.backgroundColor = currentLabelBgColor.value;

        if (JSON.stringify(canvasAsJson)) resolve(JSON.stringify(canvasAsJson));
        else reject(undefined);
      },
      ["name", "id"]
    );
  });
};

export const setCanvasJPEG = (): string | undefined => {
  const canvasObjects = canvas.value.getObjects();

  const mainLabel = new fabric.Group(undefined, {
    name: "mainLabel",
    originX: "center",
    originY: "center",
    evented: false,
    selectable: false,
  });

  const labelSize = fabric.util.object.clone(
    canvasObjects.find((obj) => obj.name === "actualLabelSize")
  );

  if (labelSize) {
    labelSize.set({
      fill: currentLabelBgColor.value,
      strokeWidth: 0,
    });

    mainLabel.addWithUpdate(labelSize);

    for (const obj of canvasObjects) {
      if (
        obj.name === "svgShape" ||
        obj.name === "clipArt"  ||
        obj.name === "iText"    ||
        obj.name === "image"    ||
        obj.name === "group"
      ) {
        mainLabel.addWithUpdate(fabric.util.object.clone(obj));
      }
    }

    const labelLeft = labelSize.left as number;
    const labelTop = labelSize.top as number;
    const labelWidth = labelSize.width as number;
    const labelHeight = labelSize.height as number;
    const labelScaleX = labelSize.scaleX as number;
    const labelScaleY = labelSize.scaleY as number;

    const groupWidth = mainLabel.width as number;
    const groupHeight = mainLabel.height as number;
    const groupScaleX = mainLabel.scaleX as number;
    const groupScaleY = mainLabel.scaleY as number;

    const labelScaledWidth = labelWidth * labelScaleX;
    const labelScaledHeight = labelHeight * labelScaleY;

    const groupScaledWidth = groupWidth * groupScaleX;
    const groupScaledHeight = groupHeight * groupScaleY;

    let adjustLeft = (groupScaledWidth - labelScaledWidth) / 2;
    let adjustTop = (groupScaledHeight - labelScaledHeight) / 2;

    if (isRotated.value) {
      adjustLeft = (groupScaledWidth - labelScaledHeight) / 2;
      adjustTop = (groupScaledHeight - labelScaledWidth) / 2;
    }

    return mainLabel.toDataURL({
      format: "jpeg",
      quality: 1.0,
      left: labelLeft + adjustLeft,
      top: labelTop + adjustTop,
      width: isRotated.value ? labelScaledHeight : labelScaledWidth,
      height: isRotated.value ? labelScaledWidth : labelScaledHeight,
    });
  }
};
